
export const ANIM_TYPES = [
    { label: "FADE", value: "FADE" },
    { label: "FLIP", value: "FLIP" },
    { label: "SLIDE", value: "SLIDE" },
    { label: "ZOOM", value: "ZOOM" },
    { label: "SCROLL", value: "SCROLL" },
    { label: "ROLL", value: "ROLL" },
    { label: "DISSOLVE", value: "DISSOLVE" },
];

export const ALL_DIRECTIONS = {
    FLIP: ["HORIZONTAL", "VERTICAL"],
    SLIDE: ["LEFT", "RIGHT", "UP", "DOWN"],
    ZOOM: ["CENTER", "LEFT", "RIGHT", "UP", "DOWN"],
    SCROLL: ["LEFT", "RIGHT", "UP", "DOWN"],
    ROLL: ["LEFT", "RIGHT", "UP", "DOWN"],
};